import { render, staticRenderFns } from "./DragObject.vue?vue&type=template&id=7b27a246&scoped=true"
import script from "./DragObject.vue?vue&type=script&lang=js"
export * from "./DragObject.vue?vue&type=script&lang=js"
import style0 from "./DragObject.vue?vue&type=style&index=0&id=7b27a246&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b27a246",
  null
  
)

export default component.exports